import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HrmsService } from '../hrms.service';
import { ColDef, ExcelExportParams, ExcelStyle, GridApi, GridReadyEvent, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';

@Component({
  selector: 'app-employee-exit-details',
  templateUrl: './employee-exit-details.component.html',
  styleUrls: ['./employee-exit-details.component.scss']
})
export class EmployeeExitDetailsComponent implements OnInit {
  private readonly monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  private gridApi!: GridApi<any>;
  quickFilter: string = '';
  monthYearOptions: { label: string; value: string }[] = [];
  selectedMonthYear = '';
  canExportExcel = false;

  constructor(private spinner: NgxSpinnerService, private Service: HrmsService) { }

  ngOnInit(): void {
    this.monthYearOptions = this.buildMonthYearOptions();
    this.selectedMonthYear = this.monthYearOptions[0]?.value ?? '';
    this.hrmsEmployeeExit();
  }

  private buildMonthYearOptions(): { label: string; value: string }[] {
    const options: { label: string; value: string }[] = [];
    const now = new Date();
    for (let i = 0; i < 11; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const month = this.monthAbbreviations[date.getMonth()];
      const year = date.getFullYear();
      options.push({
        label: `${month} ${year}`,
        value: `${month}-${year}`,
      });
    }
    return options;
  }

  onMonthYearChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    if (!value || value === this.selectedMonthYear) {
      return;
    }
    this.selectedMonthYear = value;
    this.hrmsEmployeeExit();
  }

  rowData: any[] = [];
  pinnedTopRowData: any[] = [];

  defaultExcelExportParams: ExcelExportParams = {
    exportAsExcelTable: true,
  };

  colDefs: ColDef<any>[] = [
    {
      field: 'payrollId', headerName: 'Payroll Id',
      minWidth: 150,
      maxWidth: 200,
      pinned: "left",
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'company', headerName: 'Company Name',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'employeeType', headerName: 'Employee Type',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'cityName', headerName: 'City Name',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'payrollZone', headerName: 'Payroll Zone',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'campusName', headerName: 'Campus Name',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'buildingName', headerName: 'Building Name',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'employeeName', headerName: 'Employee Name',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'designationName', headerName: 'Designation Name',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'subject', headerName: 'Subject',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'dob', headerName: 'DOB',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'doj', headerName: 'DOJ',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'dol', headerName: 'DOL',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'pan', headerName: 'PAN',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'grade', headerName: 'Grade',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'campusCode', headerName: 'Campus Code',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'buildingCode', headerName: 'Building Code',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'costCenterName', headerName: 'CostCenter Name',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'costCenterCode', headerName: 'CostCenter Code',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'campusType', headerName: 'Campus Type',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'structure', headerName: 'Structure',
      minWidth: 200,
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },

  ]

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };

  hrmsEmployeeExit() {
    if (!this.selectedMonthYear) {
      return;
    }
    this.canExportExcel = false;
    this.spinner.show();
    this.Service.getEmployeeExitDetails(this.selectedMonthYear).subscribe({
      next: (res: any) => {
        if (!res) {
          this.rowData = [];
          this.canExportExcel = false;
          this.spinner.hide();
          return;
        }
        this.rowData = Array.isArray(res) ? res : [];
        this.canExportExcel = this.rowData.length > 0;
        this.spinner.hide();
      },
      error: () => {
        this.rowData = [];
        this.canExportExcel = false;
        this.spinner.hide();
      }
    });
  }

  excelStyles: ExcelStyle[] = [
    {
      id: 'headerCell',
      font: { bold: true, size: 20 },
      alignment: { horizontal: 'Center', vertical: 'Center' },
    }
  ];

  onBtExport() {
    if (!this.canExportExcel || !this.gridApi) {
      return;
    }
    const params: ExcelExportParams = {
      fileName: 'HRMS_Employee_Exit_Details',
      sheetName: 'HRMS Employee Exit Details',

      prependContent: [
        {
          cells: [
            {
              styleId: 'headerCell',
              data: {
                type: 'String',   // ← old versions use plain string
                value: 'HRMS EMPLOYEE EXIT DETAILS REPORT'
              },
              mergeAcross: 21
            }
          ]
        },
        {
          cells: []  // blank row
        }
      ]
    };

    this.gridApi.exportDataAsExcel(params);
    alert("Excel Report generated. Please check Downloads.");
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
  }

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }

}
